import { postRequest } from "../../../services/RestServices";
import * as urls from "../../api/scheduler/url";
export const getJobs = async (payload) => {
  try {
    return await postRequest(urls.GET_JOBS, payload);
  } catch (err) {
    return err;
  }
};

export const getJobsV3 = async (payload) => {
  try {
    return await postRequest(urls.GET_JOBS_NEW, payload);
  } catch (err) {
    return err;
  }
};
